import styled from 'styled-components'

const AttachmentsIconUi = styled.i`
  margin-left: 15px;
`

export default AttachmentsIconUi
